module.exports = __webpack_public_path__ + "static/media/reactibook.3039edfe.PNG";